module.exports = __webpack_public_path__ + "static/img/kf.c118a5fd.png";